import { render, staticRenderFns } from "./SideOpacitySlider.vue?vue&type=template&id=6e1894e9&scoped=true"
import script from "./SideOpacitySlider.vue?vue&type=script&lang=js"
export * from "./SideOpacitySlider.vue?vue&type=script&lang=js"
import style0 from "./SideOpacitySlider.vue?vue&type=style&index=0&id=6e1894e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1894e9",
  null
  
)

export default component.exports